export default __webpack_public_path__ + "static/media/noun-funding-2763957.47c0a531.svg";